module.exports = "/images/vendor/vue-paycard/src/23.jpg?7fe26666841f09fd229d96696e5cc874";